import { render } from "./AddSupportCours.vue?vue&type=template&id=0e0d2fca&scoped=true&ts=true"
import script from "./AddSupportCours.vue?vue&type=script&lang=ts"
export * from "./AddSupportCours.vue?vue&type=script&lang=ts"

import "./AddSupportCours.vue?vue&type=style&index=0&id=0e0d2fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0d2fca"]])

export default __exports__